import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import LeaveCardAccordian from "./LeaveCardAccordian";
import { convertStraight } from "../../common-data/Converts";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const StaffListingMobile = ({
  tableData,
  setClickValues,
  tablePagination,
  isPage,
  setIsPage,
  isLeadLoading,
  handleDelete,
  userInfoData,
  setModValues,
  isStaff,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((staff, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  {!isStaff ? (
                    <h3 className="lead-name">{staff?.user_name || "NA"}</h3>
                  ) : null}

                  <span className={`lead-type staff-leave-cat`}>
                    {staff?.leave_category_name?.replace(/_/g, " ") || "NA"}
                  </span>
                </div>

                {!isStaff ? (
                  <div className="card-other-info">
                    <span className="value semi-bold">
                      {staff?.user_mobile || "NA"}
                    </span>
                    {staff?.email ? (
                      <span className="value email semi-bold">
                        {staff?.user_email || "NA"}
                      </span>
                    ) : null}
                    <span className="value semi-bold">
                      {staff?.gym_name || "NA"}
                    </span>

                    <span className="value semi-bold">
                      Leave Applied On :
                      <b>
                        {" "}
                        {staff?.apply_date
                          ? convertStraight(staff.apply_date)
                          : "-"}
                      </b>
                    </span>

                    <span className="value semi-bold">
                      Staff Designation :<b> {staff?.account_type || "NA"}</b>
                    </span>

                    <span className="value semi-bold">
                      Leave Terms fulfilled :
                      <b>
                        {" "}
                        {staff?.matrix_status === "matched" ? (
                          <CheckCircleIcon />
                        ) : (
                          <CrossCircleIcon />
                        )}
                      </b>
                    </span>
                  </div>
                ) : null}

                {isStaff ? (
                  <div className="card-other-info mt15">
                    <span className="value semi-bold">
                      Total Leave Days Applied -{" "}
                      <b>{staff?.total_leave_days_applied || 0}</b>
                    </span>
                    <span className="value semi-bold">
                      Total Leave Days Approved -{" "}
                      <b>{staff?.total_leave_days_approved || 0}</b>
                    </span>
                    <span className="value semi-bold">
                      Total Leave Days Rejected -{" "}
                      <b>{staff?.total_leave_days_rejected || 0}</b>
                    </span>
                    <span className="value semi-bold">
                      Leave Applied On :
                      <b>
                        {" "}
                        {staff?.apply_date
                          ? convertStraight(staff.apply_date)
                          : "-"}
                      </b>
                    </span>

                    <span className="value semi-bold">
                      Leave Terms fulfilled :
                      <b>
                        {" "}
                        {staff?.matrix_status === "matched" ? (
                          <CheckCircleIcon />
                        ) : (
                          <CrossCircleIcon />
                        )}
                      </b>
                    </span>
                  </div>
                ) : null}

                <LeaveCardAccordian
                  rowData={staff}
                  setClickValues={setClickValues}
                  handleDelete={handleDelete}
                  isLeadLoading={isLeadLoading}
                  userInfoData={userInfoData}
                  isStaff={isStaff}
                  setModValues={setModValues}
                />
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default StaffListingMobile;
